import { textTruncate } from '../../styles/commonStyles';
import RupTooltip from '../rupTooltip';
import WrappedText from '../wrappedText';
import Box from '@mui/material/Box';
import { Colors, Icons, localize } from 'copyright-clearance-center-common-ui';

export interface ITagProps {
	tag: string;
	selected?: boolean;
	exists?: boolean;
	isNew?: boolean;
	testId?: string;
	onClear?: (tag: string) => void;
	onClick?: (tag: string) => void;
}

const Tag: React.FunctionComponent<ITagProps> = props => {
	const getBackground = () => {
		if (props.selected) {
			return Colors.neutral400;
		}

		if (props.exists) {
			return Colors.neutral500;
		}
	};

	const getBorder = () => {
		if (props.isNew) {
			return `2px solid ${Colors.primary500}`;
		}
	};

	const getState = () => {
		if (props.selected) {
			return 'selected';
		} else if (props.exists) {
			return 'duplicate';
		} else if (props.isNew) {
			return 'new';
		}

		return 'old';
	};

	return (
		<RupTooltip
			disableHoverListener={!props.exists}
			title={localize('This tag already exists')}
			describeChild
			arrow
		>
			<Box
				onClick={() => {
					if (props.onClick) {
						props.onClick(props.tag);
					}
				}}
				overflow="hidden"
				className="rup-tag"
				sx={{
					color: props.selected || props.exists ? Colors.neutral600 : undefined,
					background: getBackground(),
					border: getBorder()
				}}
				data-test-id={props.testId || 'tag'}
				data-state={getState()}
			>
				{props.exists ? <Box sx={textTruncate}>{props.tag}</Box> : <WrappedText text={props.tag} />}
				{props.onClear && (
					<button
						className="rup-tag__close rup-icon-btn rup-icon-btn--neutral rup-icon-btn--xs"
						type="button"
						data-test-id="clear-btn"
						onClick={e => {
							e.stopPropagation();
							props.onClear(props.tag);
						}}
					>
						<span dangerouslySetInnerHTML={{ __html: Icons.ClearIcon }} />
					</button>
				)}
			</Box>
		</RupTooltip>
	);
};

export default Tag;
